import { Component, OnInit, Output, EventEmitter } from '@angular/core';
@Component({
  selector: 'ngx-app-recette',
  templateUrl: './recette.component.html',
})
export class RecetteComponent implements OnInit {

  constructor() { }
  ngOnInit() {
  }

}
